import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3bc5c204")
const _hoisted_1 = {
  class: "medium-img rounded position-relative border",
  id: "image"
}
const _hoisted_2 = { class: "font-weight-bold" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-pen" }, null, -1)
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.user.type === 'administrator')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "img-overlay medium-img rounded d-flex justify-content-center align-items-center",
          title: "Neues Bild hochladen",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.input.click()))
        }, [
          _createElementVNode("span", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.$t("messages.change")) + " ", 1),
            _hoisted_3
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("img", {
      src: _ctx.book.imageUrl,
      alt: _ctx.$t('messages.no cover'),
      class: "medium-img rounded bg-black"
    }, null, 8, _hoisted_4),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("input", {
          id: "inputId",
          ref: "input",
          type: "file",
          style: {"position":"fixed","top":"-100em"},
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.newCover && _ctx.newCover(...args)))
        }, null, 544)
      ])
    ])
  ]))
}